// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".0f925c993a024dd14fd14112dc9c205d7c08b23e.chunk.js";
};